import {Action} from '@ngrx/store';
import {GetDressCodePicturesSuccessAction} from '../actions/dress-code-pictures/get-dress-code-pictures-success-action';
import {GetDressCodePicturesErrorAction} from '../actions/dress-code-pictures/get-dress-code-pictures-error-action';
import {DressCodePicturesState} from '../states/dress-code-pictures-state';
import {AddDressCodePictureErrorAction} from '../actions/dress-code-pictures/add-dress-code-picture-error-action';
import {DeleteDressCodePictureErrorAction} from '../actions/dress-code-pictures/delete-dress-code-picture-error-action';
import {AddDressCodePictureAction} from '../actions/dress-code-pictures/add-dress-code-picture-action';
import {DeleteDressCodePictureAction} from '../actions/dress-code-pictures/delete-dress-code-picture-action';
import {GetDressCodePicturesAction} from '../actions/dress-code-pictures/get-dress-code-pictures-action';
import {Deserialize, Serialize} from 'cerialize';

const initialState = new DressCodePicturesState();

export function DressCodePicturesReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: DressCodePicturesState = Deserialize(serializedState, DressCodePicturesState);

  switch (action.type) {
    case GetDressCodePicturesAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetDressCodePicturesSuccessAction.type:
      state.ready = true;
      state.dressCodePictures = (<GetDressCodePicturesSuccessAction>action).dressCodePictures;
      state.error = null;
      break;

    case GetDressCodePicturesErrorAction.type:
      state.ready = true;
      state.error = (<GetDressCodePicturesErrorAction>action).error;
      break;

    case AddDressCodePictureAction.type:
      state.ready = false;
      state.error = null;
      break;

    case AddDressCodePictureErrorAction.type:
      state.ready = true;
      state.error = (<AddDressCodePictureErrorAction>action).error;
      break;

    case DeleteDressCodePictureAction.type:
      state.ready = false;
      state.error = null;
      break;

    case DeleteDressCodePictureErrorAction.type:
      state.ready = true;
      state.error = (<DeleteDressCodePictureErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
